import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as globalLoaderSelectors from './selectors';

export default reducer;
